import { useState, FormEvent } from "react";

const contactInfo = [
  {
    icon: "ri-map-pin-line",
    label: "Address",
    value: "STOJANA NOVAKOVICA 17A, LOK. 1",
  },
  { icon: "ri-building-2-line", label: "City", value: "Nis" },
  { icon: "ri-mail-line", label: "Zip", value: "700224" },
  { icon: "ri-global-line", label: "Country", value: "Serbia" },
  {
    icon: "ri-at-line",
    label: "Email",
    value: "contact@mahherc.com",
  },
  {
    icon: "ri-phone-line",
    label: "Number",
    value: "+1 6202099901",
  },
];

export default function ContactSection() {
  const [status, setStatus] = useState<"idle" | "sending" | "success" | "error">("idle");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("sending");

    const form = e.currentTarget;
    const data = new URLSearchParams();
    const elements = form.elements;
    for (let i = 0; i < elements.length; i++) {
      const el = elements[i] as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement;
      if (el.name) {
        data.append(el.name, el.value);
      }
    }

    try {
      const res = await fetch("https://readdy.ai/api/form/d7fm9d95vm7vckkoe7hg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });
      if (res.ok) {
        setStatus("success");
        form.reset();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <section id="contact" className="py-24 md:py-36 bg-[#0f0f0f] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16">
          <span className="text-xs uppercase tracking-[0.3em] text-white/40 font-medium mb-4 block">
            / Contact /
          </span>
          <h2 className="text-4xl md:text-5xl font-extrabold leading-tight tracking-tight">
            Get in Touch
            <br />
            <span className="text-white/30">We would love to hear from you</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          {/* Contact info */}
          <div>
            <p className="text-white/50 text-base leading-relaxed mb-10">
              Whether you have questions about our products, need support, or
              simply want to connect — our team is here and ready to respond.
            </p>

            <div className="space-y-5">
              {contactInfo.map((item) => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white/5 border border-white/10 rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-white/50 text-base w-4 h-4 flex items-center justify-center`} />
                  </div>
                  <div>
                    <div className="text-xs uppercase tracking-widest text-white/30 mb-0.5">
                      {item.label}
                    </div>
                    <div className="text-white/80 text-sm font-medium">{item.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Contact form */}
          <div>
            <form
              data-readdy-form
              id="mahherc-contact-form"
              onSubmit={handleSubmit}
              className="space-y-4"
            >
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">
                    First Name
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    required
                    placeholder="John"
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                  />
                </div>
                <div>
                  <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    required
                    placeholder="Doe"
                    className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="you@example.com"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                />
              </div>

              <div>
                <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  name="subject"
                  required
                  placeholder="How can we help?"
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors"
                />
              </div>

              <div>
                <label className="block text-xs uppercase tracking-widest text-white/40 mb-2">
                  Message
                </label>
                <textarea
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="Write your message here..."
                  className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder-white/20 focus:outline-none focus:border-white/30 transition-colors resize-none"
                />
                <p className="text-xs text-white/20 mt-1">Max 500 characters</p>
              </div>

              <button
                type="submit"
                disabled={status === "sending" || status === "success"}
                className="w-full bg-white text-gray-900 rounded-xl py-3.5 text-sm font-bold uppercase tracking-widest hover:bg-white/90 transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
              >
                {status === "sending"
                  ? "Sending..."
                  : status === "success"
                  ? "Message Sent!"
                  : "Send Message"}
              </button>

              {status === "success" && (
                <p className="text-green-400 text-sm text-center">
                  Thank you! We will get back to you shortly.
                </p>
              )}
              {status === "error" && (
                <p className="text-red-400 text-sm text-center">
                  Something went wrong. Please try again.
                </p>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Footer bar */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-20 pt-8 border-t border-white/10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-white/30 text-sm">
            &copy; {new Date().getFullYear()} MAHHERC. All Rights Reserved.
          </span>
          <div className="flex items-center gap-6">
            <span className="text-white/20 text-xs uppercase tracking-widest">
              Privacy Policy
            </span>
            <span className="text-white/10">|</span>
            <span className="text-white/20 text-xs uppercase tracking-widest">
              Terms of Use
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
